import { createContext, useContext, useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };
  const setSession = (_token, u) => setUser(u);
  const logout = () => { api.post("/auth/logout").catch(() => {}); setUser(false); };
  const refreshUser = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, setSession, refreshUser, apiErr }}>
      {children}
    </AuthCtx.Provider>
  );
}
